export default () => {
    const serverName = localStorage.getItem('server')
    const defaultServer = JSON.parse(process.env.VUE_APP_API_SERVERS)[0]

    if (serverName) {
        const server =  (JSON.parse(process.env.VUE_APP_API_SERVERS) || [])
            .find(item => item.name === serverName)

        return server ? server : defaultServer
    } else {
        return defaultServer
    }

}
